module.exports = __webpack_public_path__ + "img/onboarding.0d0f15fd.svg";